import { useRef } from 'react';
import _useRootClose from 'react-overlays/useRootClose';
function useRootClose(onRootClose, options) {
  var rootElementRef = useRef(null);
  _useRootClose(rootElementRef.current, onRootClose, options);
  return rootElementRef;
}
export default useRootClose;